import * as React from 'react';
import { Mutation, MutationFn } from 'react-apollo';

import { CoachingUserType } from 'globalTypes';
import CREATE_COACHING_SESSION_MUTATION from 'coaching/mutations/CreateCoachingSession.gql';
import {
  CreateCoachingSession,
  CreateCoachingSessionVariables,
} from 'coaching/mutations/__generated__/CreateCoachingSession';
import GET_COACHING_SESSIONS_QUERY from 'coaching/queries/GetCoachingSessions.gql';
import ToastActions from 'actions/ToastActions';

export type Props = {
  participantUuid?: string;
  userType: CoachingUserType;
  children: (props: {
    createCoachingSession: MutationFn<CreateCoachingSession, CreateCoachingSessionVariables>;
  }) => React.ReactNode;
};

export default function CreateCoachingSessionContainer(props: Props) {
  return (
    <Mutation<CreateCoachingSession, CreateCoachingSessionVariables>
      mutation={CREATE_COACHING_SESSION_MUTATION}
      onCompleted={() => {
        ToastActions.showSuccessToast('Created coaching session');
      }}
      onError={error => ToastActions.showErrorToast(error.message)}
      refetchQueries={[
        {
          query: GET_COACHING_SESSIONS_QUERY,
          variables: { userUuid: props.participantUuid, userType: props.userType },
        },
      ]}>
      {createCoachingSession => {
        return props.children({ createCoachingSession });
      }}
    </Mutation>
  );
}
